import { customAlphabet } from 'nanoid';

// This is to ensure nano id will produce ID compatible with most other services, i.e. ES, GCP ...
const nanoid = customAlphabet('1234567890abcdefghijklmnopqrstuvwxyz', 10);

export function getUUID(len = 10) {
  return nanoid(len);
}
